import { render, staticRenderFns } from "./NoSubscriptionView.vue?vue&type=template&id=22ab99c4&scoped=true&"
import script from "./NoSubscriptionView.vue?vue&type=script&lang=js&"
export * from "./NoSubscriptionView.vue?vue&type=script&lang=js&"
import style0 from "./NoSubscriptionView.vue?vue&type=style&index=0&id=22ab99c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ab99c4",
  null
  
)

export default component.exports